/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {config} from "../config";
// async components
import {
    AsyncUserHistoryListComponent,
    AsyncUserHistoryShowComponent,
} from "../components/AsyncComponent/AsyncComponent";

const UserHistory: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();

    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('userHistory.name')}`}</title>
                <meta name="description" content="UserHistory"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncUserHistoryListComponent}/>
                <Route exact path={`${match?.url}/:id/show`} component={AsyncUserHistoryShowComponent}/>
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`}/>
            </Switch>
        </div>
    );
};

export default UserHistory;
